import React from "react";
import { useParams } from "react-router-dom";
import ContractPatternForm from "./ContractPatternForm";

export default function EditContractPattern() {
  const params = useParams();
  return <ContractPatternForm patternId={params.id} />;
}
